var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.067,
    height: 19.067,
    viewBox: "0 0 19.067 19.067",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pastealt",
    d: "M17.908,19.068H9.566a1.177,1.177,0,0,1-1.192-1.192V7.151a1.16,1.16,0,0,1,.345-.838,1.137,1.137,0,0,1,.847-.354h4.767v4.767H19.1v7.15a1.177,1.177,0,0,1-1.192,1.192ZM15.525,5.977a1.031,1.031,0,0,1,.6.279l2.662,2.737a.966.966,0,0,1,.261.54H15.525V5.977ZM13.141,2.384H11.949V1.192h1.192a1.137,1.137,0,0,1,.847.354,1.16,1.16,0,0,1,.345.838V4.767H13.141V2.384ZM9.566,3.575H4.8A1.177,1.177,0,0,1,3.608,2.393a1.172,1.172,0,0,1,.345-.847A1.134,1.134,0,0,1,4.8,1.192,1.16,1.16,0,0,1,5.144.355,1.137,1.137,0,0,1,5.991,0H8.375a1.137,1.137,0,0,1,.847.354,1.16,1.16,0,0,1,.345.838,1.137,1.137,0,0,1,.847.354,1.171,1.171,0,0,1,.345.847,1.139,1.139,0,0,1-.345.838,1.154,1.154,0,0,1-.847.345ZM1.224,16.684H7.183v1.192H1.224a1.16,1.16,0,0,1-.838-.345,1.137,1.137,0,0,1-.354-.847V2.384a1.16,1.16,0,0,1,.345-.838,1.137,1.137,0,0,1,.847-.354H2.417V2.385H1.225v14.3Z",
    transform: "translate(-0.033 -0.001)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderManagementIcon);
export default __webpack_public_path__ + "static/media/order-management-icon.89086f5eb95afc753b6f83567d4fa471.svg";
export { ForwardRef as ReactComponent };